<script>
import {mapActions} from "vuex";
import PrefectureList from "../../mixins/PrefectureList"

export default {
  name: "SearchZipModal",
  components: {},
  mixins:[
    PrefectureList
  ],
  props: {
    enable: {
      type: Boolean,
      default: () => false,
    },
    initialPrefectureCode: {
      type: String,
      default: () => null,
    },
    initialCityName: {
      type: String,
      default: () => null
    },
    initialTownName: {
      type: String,
      default: () => null
    },
    smallButton: {
      type: Boolean,
      default: () => true
    },
    xSmallButton: {
      type: Boolean,
      default: () => false
    },
  },
  data () {
    return {
      enableDialog: false,
      enableReflectedMessage: false,
      /**
       * 検索フォーム
       * @property searchForm.prefectureCode { string } 都道府県コード
       * @property searchForm.city { string } 市区町村
       * @property searchForm.town { object } 町域
       */
      searchForm: {
        prefectureCode: null,
        city: null,
        town: null,
        townName: null,
      },
      reloader: 0,
      prefectures: [],
      cities: [],
      towns: [],
    }
  },
  computed: {},
  watch: {
    enable (value) {
      this.prefectures = []
      this.cities = []
      this.towns = []
      this.$nextTick(() => this.$refs.zipObserver.reset())
      Object.assign(this.searchForm, this.$options.data().searchForm);
      this.reloader += 1;
      this.prefectures = this.prefList
      if (value) {
        // propsの値をセット
        this.searchForm.prefectureCode = this.initialPrefectureCode;
        this.searchForm.city = this.initialCityName;
        this.searchForm.townName = this.initialTownName;
        // 都道府県が指定されている場合は都道府県コードから市区町村を展開
        if (this.initialPrefectureCode) {
          this.prefectureChangeEvent(true);
        }
        this.$nextTick(() => this.searchZipButtonClickEvent())

      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions("DriverMasterSearchAddressesCity", {
      fetchCities: "index"
    }),
    ...mapActions("DriverMasterSearchAddressesTown", {
      fetchTowns: "index"
    }),
    ...mapActions("DriverMasterSearchZipCode", {
      searchZipCode: "show"
    }),
    /**
     * 都道府県 チェンジイベント
     * @param {boolean} isInitial - 初期表示での呼び出しはtrue
     */
    prefectureChangeEvent (isInitial = false) {
      if (!isInitial) {
        this.searchForm.city = null
        this.searchForm.town = null
      }
      this.cities = []
      this.towns = []
      this.fetchCities({ params: { prefecture_code: this.searchForm.prefectureCode } }).then((content) => {
        this.cities = content.cities
        if (isInitial && this.searchForm.city) {
          this.cityChangeEvent(isInitial)
        }
      })
    },
    /**
     * 市区町村 チェンジイベント
     * @param {boolean} isInitial - 初期表示での呼び出しはtrue
     */
    cityChangeEvent (isInitial = false) {
      this.searchForm.town = null
      this.towns = []
      this.fetchTowns({ params: { prefecture_code: this.searchForm.prefectureCode, city_name: this.searchForm.city } }).then((content) => {
        this.towns = content.towns
        if (isInitial && this.searchForm.townName) {
          const found = this.towns.find((town) => town.town === this.searchForm.townName);
          if (found) {
            this.searchForm.town = found;
          }
        }
      })
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.enableDialog = false;
      this.$emit("closeCallback")
    },
    /**
     * 反映ボタン クリックイベント
     */
    reflectButtonClickEvent () {
      const returnValue = {
        zip_code: this.searchForm.town.zip_code,
        prefecture_code: this.searchForm.town.prefecture_code,
        city: this.searchForm.town.city,
        town: this.searchForm.town.town,
      }
      this.enableReflectedMessage = true;
      this.$emit("reflectFullCallback", returnValue)
      this.closeButtonClickEvent();
    },
    /**
     * 郵便番号検索ボタン クリックイベント
     */
    searchZipButtonClickEvent () {

      if (this.nullToBlank(this.initialTownName) === '') {
        this.enableDialog = true;
        return;
      }

      const params = {
        prefecture_code: this.initialPrefectureCode,
        address_1: this.initialCityName,
        address_2: this.initialTownName,
      };
      // 住所から郵便番号の逆引き
      this.searchZipCode({params: params}).then((content) => {
        // 郵便番号が存在する場合
        if (content.zip_code) {
          /*
           * 1. 呼び出し元に郵便番号を受渡し
           * 2. 反映メッセージを表示
           * 3. モーダルを閉じる
           */
          this.$emit("reflectZipCallback", content.zip_code)
          this.enableReflectedMessage = true;
          this.$emit("closeCallback")
        } else {
          this.enableDialog = true;
        }
      });
    },
    },
}
</script>

<template>
  <div>
    <v-dialog
      v-model="enableDialog"
      width="800"
      @click:outside="closeButtonClickEvent"
      @keydown.esc="closeButtonClickEvent"
    >
      <validation-observer
        ref="zipObserver"
        v-slot="{ invalid }"
      >
        <v-card>
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>郵便番号検索</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row dense>
                <!-- 都道府県 -->
                <v-col cols="12" md="4">
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                    name="都道府県"
                    class="requiredMark"
                  >
                    <v-autocomplete
                      v-model="searchForm.prefectureCode"
                      :error-messages="errors"
                      :items="prefectures"
                      :key="reloader"
                      dense
                      hide-details="auto"
                      item-text="text"
                      item-value="value"
                      label="都道府県"
                      outlined
                      persistent-placeholder
                      placeholder="例）東京都"
                      ref="prefecture"
                      required
                      @change="prefectureChangeEvent"
                    />
                  </validation-provider>
                </v-col>
                <!-- /都道府県 -->
                <!-- 市区町村 -->
                <v-col cols="12" md="4">
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                    name="市区町村"
                    class="requiredMark"
                  >
                    <v-autocomplete
                      v-model="searchForm.city"
                      :error-messages="errors"
                      :items="cities"
                      :key="reloader"
                      dense
                      label="市区町村"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                      required
                      @change="cityChangeEvent"
                    />
                  </validation-provider>
                </v-col>
                <!-- /市区町村 -->
                <!-- 町域 -->
                <v-col cols="12" md="4">
                  <validation-provider
                    v-slot="{ errors }"
                    name="町域"
                    rules="required"
                    class="requiredMark"
                  >
                    <v-autocomplete
                      v-model="searchForm.town"
                      :error-messages="errors"
                      :items="towns"
                      :key="reloader"
                      dense
                      label="町域"
                      hide-details="auto"
                      outlined
                      return-object
                      persistent-placeholder
                    />
                  </validation-provider>
                </v-col>
                <!-- /町域 -->
              </v-row>
              <v-row dense>
                <v-col cols="4">
                  <v-subheader>
                    <span class="mr-3">郵便番号</span>
                    <template v-if="!searchForm.town">
                      -
                    </template>
                    <template v-else>
                      <strong>{{ searchForm.town?.zip_code }}</strong>
                    </template>
                  </v-subheader>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              :disabled="invalid"
              color="primary"
              @click="reflectButtonClickEvent"
            >
              反映
            </v-btn>
          </v-card-actions>

        </v-card>
      </validation-observer>
    </v-dialog>
  </div>
</template>

<style scoped lang="scss">

</style>
